'use strict';
import classNames from 'classnames';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {FilterInput} from '../../../components/lists/FilterInput';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {TaskList} from '../../../tasks/components/TaskList';
import {isTaskType} from '../../../tasks/enums/TaskType';
import {ProjectNavigationBar} from '../ProjectNavigationBar';


function BaseProjectViewTemplateView(props) {
  return (
    <ProjectLayout
      className={classNames("ProjectViewTemplate", props.className)}
      title={props.viewTitle}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={(
        <FilterInput
          autoFilter={props.autoFilter}
          showFilterOptions={false}
          onChangeDebounce={450}
          onFilterChange={props.onFilterChange}
        />
      )}
      headerRightContent={(
        <Fragment>
          <div className="ProjectViewTemplate__desktopButtons">
            {props.canAddTask ? (
              <Button
                className="ProjectViewTemplate__addTaskButton"
                activeClassName="ProjectViewTemplate__addTaskButton_active"
                label={props.addTaskLabel}
                disabled={!props.canAddTask}
                onClick={props.onAddTask}
              />
            ) : null}
            {props.canAddMilestone ? (
              <Button
                className="ProjectViewTemplate__addMilestoneButton"
                activeClassName="ProjectViewTemplate__addMilestoneButton_active"
                label={props.addMilestoneLabel}
                onClick={props.onAddMilestone}
              />
            ) : null}
          </div>
          <Button
            className="ProjectViewTemplate__headerButton"
            activeClassName="ProjectViewTasks__headerButton_active"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={(
        <ProjectNavigationBar
          taskType={props.taskType}
          target={props.project}
        />
      )}
      bannerContent={null}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <Fragment>
        <div className="ProjectViewTemplate__subHeaderButtons">
          <Button
            className="ProjectViewTemplate__expandMilestonesButton"
            label={props.isVisibilityAllCollapsed ? props.expandMilestonesLabel : props.collapseMilestonesLabel}
            onClick={props.onClickVisibilityToggleAllButton}
          />
        </div>
        <TaskList
          transitionGroupClass="ProjectLayout__content__container"
          itemClassName="ProjectLayout__content__item"
          list={props.list}
          useScroll={false}
          mode={props.mode}
          onLoadMore={props.onLoadMore}
          userId={props.userId}
          taskType={props.taskType}
          isCardMode={props.isCardMode}
          canAddTask={props.canAddTask}
          supportsDownload={false}
          canDownloadFiles={false}

          onTaskClick={props.onTaskClick}
          onTaskContextMenu={props.onTaskContextMenu}
          onClickVisibilityButton={props.onClickVisibilityButton}
          onClickOptionsButton={props.onClickOptionsButton}
          onMilestoneAddTask={props.onMilestoneAddTask}
          onMilestoneDownloadAllFiles={noop}

          init={props.init}
        />
      </Fragment>
    </ProjectLayout>
  );
}

BaseProjectViewTemplateView.propTypes = {
  className: T.string,
  userId: T.string.isRequired,
  taskType: isTaskType.isRequired,
  canAddTask: T.bool.isRequired,
  canAddMilestone: T.bool.isRequired,

  onClickOptions: T.func.isRequired,
  onTaskClick: T.func.isRequired,
  onTaskContextMenu: T.func.isRequired,
  onClickVisibilityButton: T.func.isRequired,
  onClickOptionsButton: T.func.isRequired,
  onAddTask: T.func.isRequired,
  onAddMilestone: T.func.isRequired,
  collapseMilestonesLabel: T.string,
  expandMilestonesLabel: T.string,

  viewTitle: T.string,
  addTaskLabel: T.string,
  addMilestoneLabel: T.string,

  init: T.bool,
};

BaseProjectViewTemplateView.defaultProps = {
  init: true,
};

export const ProjectViewTemplateView = I18nComponent(BaseProjectViewTemplateView, [
  {code: 'projects.views.template.title', prop: 'viewTitle'},
  {code: 'project.button.create.task.label', prop: 'addTaskLabel'},
  {code: 'project.button.create.milestone.label', prop: 'addMilestoneLabel'},
  {code: 'project.button.collapse.milestones.label', prop: 'collapseMilestonesLabel'},
  {code: 'project.button.expand.milestones.label', prop: 'expandMilestonesLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewTemplate/ProjectViewTemplateView.js